import { Box, Card, Chip, FormLabel, Stack, TextField, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';

import { InfoIcon } from 'lucide-react';
import { createChatPresetMessage, getChatPresetMessage } from '../helper/backend_helper';
import InfoTooltip from '../components/InfoTooltip';

// import logo from 'src/components/logo';

const messageVariables = [
  { token: '##GUESTNAME##', description: 'Guest full name' },
  { token: '##BNBNAME##', description: 'Property name' },
  { token: '##BOOKINGLINK##', description: 'Guest app and door access link' },
];

const VariableChips = () => (
  <Stack direction="row" gap={1} flexWrap="wrap" sx={{ mt: 1, maxWidth: 620 }}>
    {messageVariables.map((variable) => (
      <Tooltip key={variable.token} title={variable.description} arrow>
        <Chip label={variable.token} size="small" variant="outlined" />
      </Tooltip>
    ))}
  </Stack>
);

const ChatPresetMessage = () => {
  const [chatPresetMessageData, setChatPresetMessageData] = useState({});
  const [whatsAppMessageEnglish, setWhatsAppMessageEnglish] = useState('');
  const [whatsAppMessageItalian, setWhatsAppMessageItalian] = useState('');
  const [cleaningCompleteMessageToGuest, setCleaningCompleteMessageToGuest] = useState('');
  const [cleaningCompleteMessageToGuestItalian, setCleaningCompleteMessageToGuestItalian] = useState('');
  const [previousGuestLeftMessage, setPreviousGuestLeftMessage] = useState('');

  const [loading, setLoading] = useState(false);

  const Banner = async () => {
    try {
      const bannerResponse = await getChatPresetMessage();
      console.log(bannerResponse);
      setChatPresetMessageData(bannerResponse?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    Banner();
  }, []);
  useEffect(() => {
    setWhatsAppMessageEnglish(chatPresetMessageData?.whatsAppMessageEnglish || '');
    setWhatsAppMessageItalian(chatPresetMessageData?.whatsAppMessageItalian || '');
    setCleaningCompleteMessageToGuest(chatPresetMessageData?.cleaningCompleteMessageToGuest || '');
    setCleaningCompleteMessageToGuestItalian(chatPresetMessageData?.cleaningCompleteMessageToGuestItalian || '');
    setPreviousGuestLeftMessage(chatPresetMessageData?.previousGuestLeftMessage || '');
  }, [chatPresetMessageData]);

  const handleSave = async () => {
    try {
      setLoading(true);

      // Check if any field is empty
      if (whatsAppMessageEnglish.trim() === '') {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Whatsapp Message English cannot be empty',
        });
        setLoading(false);
        return;
      }

      if (whatsAppMessageItalian.trim() === '') {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Whatsapp Message Italian cannot be empty',
        });
        setLoading(false);
        return;
      }
      if (cleaningCompleteMessageToGuest.trim() === '') {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Cleaning Complete Message To Guest cannot be empty',
        });
        setLoading(false);
        return;
      }

      const BannerData = {
        whatsAppMessageEnglish,
        whatsAppMessageItalian,
        cleaningCompleteMessageToGuest,
        cleaningCompleteMessageToGuestItalian,
        previousGuestLeftMessage,
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      console.log(BannerData);

      await createChatPresetMessage(BannerData, Categoryheaders);

      // setTitle('');
      // setFormData({
      //   ...formData,
      //   profileImage: null,
      // });

      // Show success message
      Swal.fire({
        icon: 'success',
        title: 'Messages updated successfully',
      });

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error while updating Messages',
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> Preset Messages </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          // onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <Typography variant="h4">
            Chat Preset Messages{' '}
            <InfoTooltip
              width={20}
              title="The reusable WhatsApp message templates the system sends to guests automatically, in English and Italian, for events like the welcome message and the cleaning-complete notification. Templates can include variables such as ##GUESTNAME##, ##BNBNAME## and ##BOOKINGLINK## that are filled in per booking when the message is sent. Edit the wording for each template here and Update to change what guests receive."
            />
          </Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: '60ch' },
          }}
          noValidate
          autoComplete="off"
        >
          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>English Message<InfoTooltip title="English WhatsApp message sent to guests; use the variable chips below to insert dynamic values." /></FormLabel>
              <VariableChips />
              <TextField
                multiline
                minRows={4}
                label="Enter English Message"
                id="outlined-size-small"
                value={whatsAppMessageEnglish}
                onChange={(e) => setWhatsAppMessageEnglish(e.target.value)}
              />
            </Stack>
          </Stack>
          <Stack mt={3} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>Italian Message<InfoTooltip title="Italian WhatsApp message sent to guests; use the variable chips below to insert dynamic values." /></FormLabel>
              <VariableChips />
              <TextField
                multiline
                minRows={4}
                label="Enter Italian Message"
                id="outlined-size-small"
                value={whatsAppMessageItalian}
                onChange={(e) => setWhatsAppMessageItalian(e.target.value)}
              />
            </Stack>
          </Stack>

          <Stack mt={3} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>Message To Guest<InfoTooltip title="Message sent to the guest once cleaning is complete and the property is ready." /></FormLabel>
              <VariableChips />
              <TextField
                multiline
                minRows={4}
                label="Enter Message To Guest"
                id="outlined-size-small"
                value={cleaningCompleteMessageToGuest}
                onChange={(e) => setCleaningCompleteMessageToGuest(e.target.value)}
              />
            </Stack>
          </Stack>
          <Stack mt={3} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>Message To Guest Italian<InfoTooltip title="Italian version of the message sent to the guest once cleaning is complete and the property is ready." /></FormLabel>
              <VariableChips />
              <TextField
                multiline
                minRows={4}
                label="Enter Italian Message To Guest"
                id="outlined-size-small-italian"
                value={cleaningCompleteMessageToGuestItalian}
                onChange={(e) => setCleaningCompleteMessageToGuestItalian(e.target.value)}
              />
            </Stack>
          </Stack>
          <Stack mt={3} spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer' }}>
                Previous Guest Left Message To Guest
                <Tooltip title={`Variables: ##GUESTNAME##, ##BNBNAME##, ##BOOKINGLINK##`} arrow>
                  <InfoIcon size={18} />
                </Tooltip>
              </FormLabel>
              <VariableChips />
              <TextField
                multiline
                minRows={4}
                label="Enter Message To Guest"
                id="outlined-size-small"
                value={previousGuestLeftMessage}
                onChange={(e) => setPreviousGuestLeftMessage(e.target.value)}
              />
            </Stack>
          </Stack>
        </Box>
        <LoadingButton
          sx={{
            // width: 150,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Update
        </LoadingButton>
      </Card>
    </>
  );
};

export default ChatPresetMessage;
